module.exports = __webpack_public_path__ + "media/components/src/assets/images/block_link_1-d86f399767e90f89b60910ab26fc0be8.jpg";